import { Component } from '@angular/core';
import ProjectLinks from 'src/app/common/project.links';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
})
export class TermsOfUseComponent {
  public readonly TRANSLATION_KEYS: string[] = [
    'TERMS_OF_USE_MAIN_INFORMATION_PART_1',
    'TERMS_OF_USE_MAIN_INFORMATION_PART_2',
    'TERMS_OF_USE_MAIN_INFORMATION_PART_3',
    'TERMS_OF_USE_MAIN_INFORMATION_PART_4',
    'TERMS_OF_USE_MAIN_INFORMATION_PART_5',
  ];

  public readonly LINK_TERMS: string = ProjectLinks.LINK_TERMS;
}
